import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'playerStatus',
    standalone: false
})
export class PlayerStatusPipe implements PipeTransform {
    transform(value: string, ...args: any[]) {
        const normalizedValue: string = value.toLowerCase();
        switch (normalizedValue) {
            case 'checkedin':
                return 'Checked In';
            case 'noshow':
                return 'No Show';
            default:
                return value;
        }
    }

}